import {
	bi,
	n,
} from "@helpers";

import {
	getChainedTokens,
	getChainedToken,
	type ChainId,
} from "@bracket/addressbook";

import { getTokenInfo, } from "./getTokenInfo";
import { getRate } from "./getRate";
import { getEthereumPrice, } from "./getEthereumPrice";



export const totalStaked = async ({
	force = false,
}: {
	force?: boolean;
}): Promise<bigint> => {
	const totalArb = await totalStakedChain({ chain: 42161, force, });
	const totalEth = await totalStakedChain({ chain: 1, force, });
	const val =  bi( n(totalArb) + n(totalEth) );
	return val;
}


export const totalStakedChain = async ({
	chain,
	force = false,
}: {
	chain: ChainId;
	force?: boolean;
}): Promise<bigint> => {

	const ratedTokens = getChainedTokens(chain, { parity: false, });
	const parityTokens = getChainedTokens(chain, { parity: true, exclude: [ "ETH", ] });
	const tokens = [ ...ratedTokens, ...parityTokens ];
	const chainedTokens = tokens.map( tok => getChainedToken(chain, tok.label) );

	const price = await getEthereumPrice({ chain, force, });
	const info = await Promise.all(tokens.map( token => getTokenInfo({ chain, token, force, })));
	let rates = await Promise.all(ratedTokens.map(token => getRate({ token, force, })));
	rates = [ ...rates ].concat(parityTokens.map(tok => bi(1)));

	const rollup = bi(tokens.reduce((acc, token, idx) => {
		acc += n(info[idx].totalStaked) * n(rates[idx]) * n(price);
		return acc;
	}, 0));
	const _nn = n(rollup);
	return rollup;

};
